var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"address text-block"},[_c('div',{staticClass:"address-icon"}),_c('h3',{staticClass:"address-text"},[_c('a',{attrs:{"href":_vm.item.url || false,"target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(_vm.item.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }